import React from 'react';
import ProLink from '../../shared/ProLink/ProLink';
import {
  RegisterIcon,
  WarrantyIcon,
  ContactIcon
} from '../../shared/SonyIcon';
import './SwtKeySupportArea.scss'

const icons = [
  <RegisterIcon className="icon-5x" />,
  <WarrantyIcon className="icon-5x" />,
  <ContactIcon className="icon-5x" />
];

class SwtKeySupportArea extends React.Component {
  prepareData = data => {
    return Object.keys(data).reduce((newData, key) => {
      newData[key.toLowerCase()] = data[key];
      return newData;
    }, {});
  };

  render() {
    /* standard props */

    const data = this.prepareData(this.props.data);

    /**
     * standard props used in the style / function of the module.
     * Null if not specified
     **/

    const logicalName = data.logicalName || null;
    const title = data.title || null;

    if (!data) {
      return null;
    }

    return (
      <div className="key-support-wrapper module" id={logicalName}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12 key-support-title">{title}</div>
          </div>
        </div>
        <div className="row row-no-gutters">
          <div className="col-lg-12 key-support-items-wrapper">
            {data &&
              data.areas &&
              data.areas.map((area, index) => {
                return (
                  <div key={`key-support-${index}`}>
                    <ProLink
                      to={area.targetLink}
                      className="key-support-item"
                    >
                      {(area.iconURL && (
                        <div className="icon-fix">
                          <img src={area.iconURL} alt="" role="presentation" />
                        </div>
                      )) || <div role="presentation">{icons[index]}</div>}

                      <div className="key-support-subtitle">
                        {area.subTitle}
                      </div>
                    </ProLink>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    );
  }
}

export default SwtKeySupportArea;
